
require('../download-app-content/download-app-content.html');

const RegisterHtmlTemplate = require('polymer-webpack-loader/register-html-template');

RegisterHtmlTemplate.register("<dom-module id=download-app-page> <template> <style include=shared-style></style> <style>" + require("./download-app-page.css") + "</style> <slot></slot> </template> </dom-module>");

require('./download-app-page.js');



// WEBPACK FOOTER //
// ./download_app/es-US/js/download-app-page/download-app-page.html